import * as React from "react";

const SvgIcnInfo = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="currentColor" strokeWidth={1} fill="none" fillRule="evenodd">
            <circle cx={12} cy={6} r={1.5} />
            <rect x={10.5} y={10.5} width={3} height={9} rx={1.5} />
        </g>
    </svg>
);

export default SvgIcnInfo;
